import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
import { painPoints } from '../data/offer';
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-86" data-mp="2lp58b04xzixw">
      <div className="mx-auto max-w-4xl" data-id="element-87" data-mp="26xmpkukp7aau">
        <header className="text-center" data-id="element-88" data-mp="2bxiy974cbpwq">
          <h2 className="font-display text-2xl font-bold sm:text-4xl" data-id="element-89" data-mp="2bwhbw6hvjgzp">
            ¿Cuánto más vas a cargar con toda esta información?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-slate-300" style={{
          fontSize: "15px"
        }} data-id="element-90" data-mp="1y042zlreonwu">
            Tenés información esparcida por todos lados y, cuando necesitás saber qué pasó “ahora”, terminás revisando información vieja.
          </p>
          <p className="mt-4 font-semibold text-brand-light" style={{
          color: "#DE4A4A",
          fontSize: "20px"
        }} data-id="element-91" data-mp="1szpuk2lw7bya">
            Los problemas que te agobian:
          </p>
        </header>

        <div className="mt-10 space-y-3" data-id="element-92" data-mp="3nd7kfw9rskwh">
          {painPoints.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: Math.min(index * 0.04, 0.16),
          duration: 0.25,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-93" data-mp="1z0exkpa70w3q" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-94" data-mp="1g3x3403ymi3s" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-95" data-mp="1b4sv3csruqf1">{point}</p>
            </motion.div>)}
        </div>

        <p className="mt-12 text-center font-display text-2xl font-bold italic text-brand-gold sm:text-3xl" style={{
        fontSize: "22px"
      }} data-id="element-96" data-mp="1k34rxwk8ekfx">
          ¿Y si en 14 días tuvieras una síntesis clara que consultás sin abrir
          diez archivos?
        </p>
      </div>
    </section>;
}